// Globals
export const APP_NAME = 'Jetpack Jessie';
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN;

// Routes
export const ROUTE_MAIN = '/';
export const ROUTE_DASHBOARD = '/dashboard';

// Abstracted routes
export const DEFAULT_REDIRECT_URL_ONCE_LOGGED_IN = ROUTE_DASHBOARD;
